import script from "./ConfirmEmail.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfirmEmail.vue?vue&type=script&setup=true&lang=ts"

import "./ConfirmEmail.vue?vue&type=style&index=0&id=1d085ad8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d085ad8"]])

export default __exports__